var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3Dcube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7667 1.88333L16.1917 4.80833C16.825 5.14999 16.825 6.12499 16.1917 6.46666L10.7667 9.39166C10.2833 9.64999 9.71666 9.64999 9.23333 9.39166L3.80833 6.46666C3.17499 6.12499 3.17499 5.14999 3.80833 4.80833L9.23333 1.88333C9.71666 1.62499 10.2833 1.62499 10.7667 1.88333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00834 8.44167L8.05001 10.9667C8.67501 11.2833 9.07501 11.925 9.07501 12.625V17.3917C9.07501 18.0833 8.35001 18.525 7.73334 18.2167L2.69167 15.6917C2.06667 15.375 1.66667 14.7333 1.66667 14.0333V9.26667C1.66667 8.575 2.39167 8.13333 3.00834 8.44167Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9917 8.44167L11.95 10.9667C11.325 11.2833 10.925 11.925 10.925 12.625V17.3917C10.925 18.0833 11.65 18.525 12.2667 18.2167L17.3083 15.6917C17.9333 15.375 18.3333 14.7333 18.3333 14.0333V9.26667C18.3333 8.575 17.6083 8.13333 16.9917 8.44167Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dcube);
export default __webpack_public_path__ + "static/media/3dcube.96463f979e6cd21db878c4d77091293a.svg";
export { ForwardRef as ReactComponent };